import { render, staticRenderFns } from "./NotificationConfigModalGlobal.vue?vue&type=template&id=5d263b15&scoped=true"
import script from "./NotificationConfigModalGlobal.vue?vue&type=script&lang=js"
export * from "./NotificationConfigModalGlobal.vue?vue&type=script&lang=js"
import style0 from "./NotificationConfigModalGlobal.vue?vue&type=style&index=0&id=5d263b15&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d263b15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d263b15')) {
      api.createRecord('5d263b15', component.options)
    } else {
      api.reload('5d263b15', component.options)
    }
    module.hot.accept("./NotificationConfigModalGlobal.vue?vue&type=template&id=5d263b15&scoped=true", function () {
      api.rerender('5d263b15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/system/components/Modal/NotificationConfigModalGlobal.vue"
export default component.exports